import { useCallback, useState } from 'react';

/** Strip any `tcvs:<type>:` prefix and return the operator-facing id body. */
export function idTail(value: string): string {
  const lastColon = value.lastIndexOf(':');
  return lastColon === -1 ? value : value.slice(lastColon + 1);
}

export function CopyIdButton({
  value,
  label = 'Copy ID',
}: {
  value: string;
  label?: string;
}): JSX.Element {
  const [copied, setCopied] = useState(false);
  const copiedValue = idTail(value);

  const onCopy = useCallback(() => {
    const done = () => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    };

    if (navigator.clipboard?.writeText !== undefined) {
      navigator.clipboard.writeText(copiedValue).then(done, () => {
        /* Clipboard may be denied; the visible id remains selectable. */
      });
      return;
    }

    done();
  }, [copiedValue]);

  return (
    <button
      type="button"
      className="tcvs-copy-id-button"
      onClick={onCopy}
      title={`${label}: ${copiedValue}`}
      aria-label={`${label}: ${copiedValue}`}
    >
      <span className="tcvs-copy-id-icon" aria-hidden="true" />
      <span className="tcvs-copy-id-status" aria-live="polite">
        {copied ? 'Copied' : ''}
      </span>
    </button>
  );
}
